import React from 'react';
import { Space, Progress, Divider } from 'antd';
import '../styles/card.css';
import {
	AppstoreOutlined, MailOutlined, SettingOutlined, MenuUnfoldOutlined, MenuFoldOutlined, ToolOutlined, DeleteOutlined, DragOutlined,
	FontSizeOutlined,
	BarcodeOutlined,
	BorderOutlined,
	LineOutlined,
	QrcodeOutlined,
	MinusCircleOutlined,
	DownloadOutlined,
	PlayCircleOutlined,
	ClockCircleOutlined,
	CheckCircleOutlined,
	InfoCircleOutlined
 
 } from '@ant-design/icons';

const CardExec = ({ card }) => {

	return (
		<div className="card" style={{ width: (290), padding: 5 }}>
			<div className="container">
				<Space direction="horizontal" style={{ width: '100%', justifyContent: 'flex-start' }}>
					<h3 style={{ color: 'black',left:0 }}><b>{card.id}</b></h3>
				</Space>
				<Divider style={{marginTop:0, marginBottom: 10}}/>
				<Space direction="horizontal" style={{ width: '100%', justifyContent: 'center' }}>
					{card.running == true ? 
						(card.status == true ? <CheckCircleOutlined style={{ fontSize: 48 }}/> : <PlayCircleOutlined style={{ fontSize: 48 }}/>) :
						<ClockCircleOutlined style={{ fontSize: 48 }}/>}
						{/* (<PlayCircleOutlined style={{ fontSize: 20 }}/>) : <ClockCircleOutlined style={{ fontSize: 20 }}/>}
					{card.status == true ? <CheckCircleOutlined style={{ fontSize: 20 }}/> : <InfoCircleOutlined style={{ fontSize: 20 }}/>} */}
				</Space>
			</div>
			<Progress
				strokeLinecap="butt"
				percent={card.percent}
				percentPosition={{
					align: 'center',
					type: 'outer',
				}}
				size={["100%", 15]}
			/>
		</div>
	);

};

export default CardExec;